import React, { useState } from 'react';
import Swal from '../../../../helpers/swal';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import clinicService from '../../../../../services/clinic.service';
const ActionTooltipButton = ({ tooltip, tooltipId, children, ...buttonProps }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}>
        <Button {...buttonProps}>{children}</Button>
    </OverlayTrigger>
);

function MediaListItem({ item, updateMediaList }) {
    const [isCopied, setIsCopied] = useState(false);

    const handleDelete = () => {
        Swal.fire({
            title: 'Delete Media?',
            html: `<div class="text-center small">
                     <p class="small mb-0">Are you sure you want to delete <strong>${item.name}</strong>?</p>
                   </div>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `<i class="bi bi-check"></i> Yes, delete it!`,
            cancelButtonText: `<i class="bi bi-x"></i> Cancel`,
            customClass: {
                title: 'card-title',
                confirmButton: 'btn btn-danger btn-sm me-2',
                cancelButton: 'btn btn-secondary btn-sm',
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: () =>
                clinicService
                    .deleteMedia(item.clinicId, [item.id])
                    .then(() => true)
                    .catch((error) => {
                        Swal.showValidationMessage(`Delete failed: ${error.message}`);
                    }),
        }).then((result) => {
            if (result.isConfirmed) {
                updateMediaList();
            }
        });
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(item.path);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch {
            const textArea = document.createElement('textarea');
            textArea.value = item.path;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / k ** i).toFixed(1))} ${sizes[i]}`;
    };

    return (
        <div className="clinic-media-card">
            <div className="notifications-panel">
                <div className="notifications-panel__header clinic-media-card__header">
                    <span className="text-truncate small fw-semibold">{item.name}</span>
                    <ActionTooltipButton
                        tooltip="Delete media"
                        tooltipId={`delete-media-${item.id}`}
                        variant="outline-danger"
                        size="sm"
                        onClick={handleDelete}
                    >
                        <i className="bi bi-trash"></i>
                    </ActionTooltipButton>
                </div>

                <div className="notifications-panel__body">
                    <div className="clinic-media-card__thumb">
                        <img
                            src={item.path}
                            alt={item.name}
                            loading="lazy"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="%23adb5bd"%3E%3Cpath d="M8 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4V4z"/%3E%3C/svg%3E';
                            }}
                        />
                    </div>

                    <div className="clinic-media-card__meta">
                        <span className="clinic-media-meta-badge">
                            <i className="bi bi-calendar3"></i>
                            {item.modifiedAt}
                        </span>
                        <span className="clinic-media-meta-badge clinic-media-meta-badge--type">
                            <i className="bi bi-file-earmark"></i>
                            {item.type}
                        </span>
                        <span className="clinic-media-meta-badge clinic-media-meta-badge--size">
                            <i className="bi bi-hdd"></i>
                            {formatFileSize(item.sizeBytes)}
                        </span>
                    </div>

                    <div className="clinic-media-card__path">
                        <input type="text" className="form-control form-control-sm bg-light" value={item.path} readOnly aria-label="Media path" />
                        <ActionTooltipButton
                            tooltip={isCopied ? 'Copied!' : 'Copy path'}
                            tooltipId={`copy-media-${item.id}`}
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleCopy}
                        >
                            <i className={`bi ${isCopied ? 'bi-check2 text-success' : 'bi-copy'}`}></i>
                        </ActionTooltipButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediaListItem;
